export enum Type {
  boolean = 'boolean',
  string = 'string',
  number = 'number',
  date = 'date',
  object = 'object',
  blob = 'blob',
  union = 'union'
}
